import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router";
import { SupportReportsPage } from "@charphq/ui/components/layout/pages/SupportReportsPage";

const PRESETS = ["yesterday", "friday", "7d"] as const;
type Preset = (typeof PRESETS)[number];

/** Coerce to a finite positive integer, or drop the param entirely. */
function toPositiveInt(value: unknown): number | undefined {
  const n = Number(value);
  return Number.isInteger(n) && n > 0 ? n : undefined;
}

export const Route = createFileRoute("/support_/reports")({
  component: SupportReportsPageComponent,
  // SearchSchemaInput marker + all-optional output: navigations to this route
  // never require a `search` prop; the URL sync hook applies table defaults and
  // the page falls back to the "yesterday" baseline when `preset` is absent.
  // Invalid values are dropped (undefined), never passed through.
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) => {
    const sortDirection = search.sortDirection;
    return {
      preset: PRESETS.includes(search.preset as Preset) ? (search.preset as Preset) : undefined,
      page: toPositiveInt(search.page),
      pageSize: toPositiveInt(search.pageSize),
      sortBy: typeof search.sortBy === "string" && search.sortBy ? search.sortBy : undefined,
      sortDirection:
        sortDirection === "asc"
          ? ("asc" as const)
          : sortDirection === "desc"
            ? ("desc" as const)
            : undefined,
      globalFilter:
        typeof search.globalFilter === "string" && search.globalFilter
          ? search.globalFilter
          : undefined,
      columnFilters: (search.columnFilters as Record<string, unknown>) || undefined,
    };
  },
});

function SupportReportsPageComponent() {
  const search = Route.useSearch();

  return <SupportReportsPage searchParams={search} />;
}
